export function isKm220ListStation(station) {
  const name = station?.name;
  if (!name) return false;
  return !name.includes('ef-') && !name.includes('toka-') && !name.includes('g2y-') && !name.includes('viwatt-');
}

function stationSearchHaystack(station) {
  return [station?.number, station?.name, station?.notesUa, station?.notesEn]
    .filter(value => value != null && String(value).trim() !== '')
    .join(' ')
    .toLowerCase();
}

export function matchesStationSearch(station, query) {
  const q = String(query ?? '')
    .trim()
    .toLowerCase();
  if (!q) return true;
  return stationSearchHaystack(station).includes(q);
}

export function filterStationsBySearch(stations, query) {
  if (!Array.isArray(stations)) return [];
  const q = String(query ?? '').trim();
  if (!q) return stations;
  return stations.filter(station => matchesStationSearch(station, q));
}
